import { FRIDAY, MainDrawScheduleCode } from 'constants/Draw';
import { Message } from 'semantic-ui-react';

const DrawInProgressMessage = ({
  drawCode = FRIDAY,
}: {
  drawCode?: MainDrawScheduleCode;
}) => {
  return (
    <Message
      info
      icon="hourglass half"
      header="Draw in progress..."
      content={
        drawCode === FRIDAY ? (
          <p style={{ marginTop: '0.6em' }}>
            We're drawing the winning numbers for the Tuesday draw right now!
            This process can take 30 minutes as our insurer needs to audit the
            results. Please check back in a bit!
          </p>
        ) : (
          <p style={{ marginTop: '0.6em' }}>
            We're drawing the winning numbers of the Friday draw right now, LIVE
            on Instagram -&nbsp;
            <a
              href="https://www.instagram.com/daymadeuk/"
              target="_blank"
              style={{
                color: 'rgb(0,87,107)',
                textDecoration: 'underline',
                whiteSpace: 'normal',
              }}
            >
              check it out
            </a>
            !
          </p>
        )
      }
      style={{ maxWidth: '500px', padding: '2em' }}
    />
  );
};

export default DrawInProgressMessage;
